import { endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfWeek, startOfYear, subDays } from 'date-fns';

export type DateRangePreset =
  'today' | 'yesterday' | 'thisWeek' | 'last7Days' | 'thisMonth' | 'last30Days' | 'thisYear';

export const DATE_RANGE_PRESETS: readonly DateRangePreset[] = [
  'today',
  'yesterday',
  'thisWeek',
  'last7Days',
  'thisMonth',
  'last30Days',
  'thisYear',
];

/** Resolves a preset relative to `now` (weeks start on Monday). */
export function resolveDateRangePreset(preset: DateRangePreset, now: Date): { from: Date; to: Date } {
  const day = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (preset) {
    case 'today':
      return { from: day, to: day };
    case 'yesterday': {
      const y = subDays(day, 1);
      return { from: y, to: y };
    }
    case 'thisWeek':
      return { from: startOfWeek(day, { weekStartsOn: 1 }), to: endOfWeek(day, { weekStartsOn: 1 }) };
    case 'last7Days':
      return { from: subDays(day, 6), to: day };
    case 'thisMonth':
      return { from: startOfMonth(day), to: endOfMonth(day) };
    case 'last30Days':
      return { from: subDays(day, 29), to: day };
    case 'thisYear':
      return { from: startOfYear(day), to: endOfYear(day) };
  }
}
